module.exports = __webpack_public_path__ + "img/illu-heart.199f77bb.svg";